import TextField from "@mui/material/TextField/TextField";
import { useTranslation } from "react-i18next";
import { TransferDraftErrors } from "../../../../entities";
import {
  useTransferDraft,
  useTransferDraftDispatch,
} from "../../../../providers/transferDraft";
import { TransferDraftActionType } from "../../../../reducers/transferDraft";
import { fixedFieldSx } from "./fixedFieldSx";

type NameTextFieldProps = {
  disabled?: boolean;
};

export default function NameTextField({ disabled }: NameTextFieldProps) {
  const transferDraft = useTransferDraft();
  const transferDraftDispatch = useTransferDraftDispatch();
  const { t } = useTranslation();

  return (
    <TextField
      sx={fixedFieldSx}
      disabled={disabled}
      error={transferDraft.errors.has(TransferDraftErrors.blankSenderName)}
      helperText={
        transferDraft.errors.has(TransferDraftErrors.blankSenderName)
          ? t(`Please add a name in order to continue`)
          : undefined
      }
      value={transferDraft.anon.name}
      variant="filled"
      required
      fullWidth
      type="text"
      label={t(`Your name`)}
      InputProps={{
        disableUnderline: true,
      }}
      // TODO this is not triggered when auto-filling
      onChange={(newValue) => {
        transferDraftDispatch({
          type: TransferDraftActionType.senderNameUpdate,
          updatedName: newValue.target.value,
        });
      }}
    />
  );
}
